import React, {useEffect, useState} from 'react';
import {Button, Checkbox, Form, Input, Flex} from 'antd';
import moment from "moment";


function CopyrightComponent () {
    return (
        <div className="flex flex-row px-[16px] mb-[12px] font-ubold text-sm mt-[12px]">
            Powered By <span className="font-uregular text-[#00b0f0] mx-[3px]"> DreamOnline </span> © {`${moment().year()}`}
        </div>
    );
}

export default CopyrightComponent;
